import * as React from 'react'
import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import { StoreProps } from 'src/stores'
import { TranspBtn } from 'src/components/atoms/input/buttons'
import { media } from 'src/utils.js'

interface Props extends StoreProps {
  open: boolean
  title: string
  onClose: () => void
  onCancel: () => void
  onConfirm: () => void
  hideCloseButton?: boolean
  cancelLabel?: string
  confirmLabel?: string
  noBorder?: boolean
  cancelX?: boolean
  children?: any
  style?: any
}

export const CustomOptionalModal = (props: Props) => {
  const {
    children,
    open,
    onClose,
    onCancel,
    onConfirm,
    cancelLabel,
    confirmLabel,
    title,
    noBorder,
    cancelX,
    style,
    hideCloseButton
  } = props

  console.log(onCancel, onConfirm)
  return (
    <StyledModal
      id='customModal'
      show={open}
      onHide={onClose}
      backdropClassName='modal-backdrop dark-modal-backdrop in'>
      {cancelX && <CloseX onClick={onClose} />}
      <InnerModal noBorder={noBorder} style={style}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          {!hideCloseButton && (
            <React.Fragment><TranspBtn id='closeInfoModalButton' onClick={onClose}>
              {cancelLabel || 'Abbrechen'}
            </TranspBtn>
            <TranspBtn id='confirmInfoModalButton' onClick={onConfirm}>
              {confirmLabel || 'Neues Design Erstellen'}
            </TranspBtn>
          </React.Fragment>
          )}
        </ModalFooter>
      </InnerModal>
    </StyledModal>
  )
}
const StyledModal = styled(Modal)`
  padding: 0px;
  z-index: 9999;
  > * {
    > * {
      border-radius: 0;
    }
  }
`

const CloseX = props => (
  <CloseXButton {...props}>
      <i className='fas fa-times' />
    </CloseXButton>
)

const CloseXButton = styled.button`
  position: absolute;
  top: 2px;
  right: 6px;
  border: none;
  width: 38px;
  height: 38px;
  color: #9ABBBF;
  background-color: transparent;
  font-size: 24px;
  padding: 0px;
`

const InnerModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 15px;
  margin-top: 35px;
  padding: 0;
  ${(props) => !props.noBorder && 'padding: 0 10px;'}
  ${(props) => !props.noBorder && 'border: 3px #9ABBBF solid;'}
  text-align: center;
  font-size: 16px;

  ${media.desktop`font-size: 16px;`}
  ${media.tablet`font-size: 14px;`}
  ${media.largePhone`margin: 0px;`}
`

const ModalHeader = styled.div`
  ${media.largePhone`padding: 7.5px;`}
`

const ModalTitle = styled.div`
  display: inline-block;
  position: relative;
  top: -0.8em;
  padding: 0 15px;
  background: white;
  font-weight: bold;
  font-size: 25px;

  ${media.desktop`font-size: 22px;`}
  ${media.tablet`font-size: 18px;`}
  ${media.largePhone`
    margin-top: 7.5px;
    top: 0;
  `}
`

const ModalBody = styled.div`
  margin: 5px 0;
  padding: 0 7.5px;

  & > img {
    max-width: 90%;
    max-height: 350px;
    margin: 15px auto;
  }

  ul {
    max-width: 90%;
  }

  ${media.tablet`
    ul { max-width: unset; }
  `}
`

const ModalFooter = styled.div`
  margin: 2.5%;
`

export default CustomOptionalModal



// WEBPACK FOOTER //
// ./src/components/containers/CustomOptionalModal.tsx